import React, { useEffect, useRef } from 'react'
import { StyledPromoBadge, StyledSaleBadge, BadgeLabel, BadgeIcon } from './PromoBadge.css'
import { PriceTagIcon } from './icons/PriceTagIcon'
import { trackPromoBadgeImpression } from './logging/gtm/trackPromoBadgeImpression';

interface IconConfig {
  type: string;
  style: React.CSSProperties;
  enabled: boolean;
  content: string;
}

const SaleBadge = ({ config }) => {
  const handleClick = () => {
    if (config?.button?.onClick?.url) {
      // Validate URL to prevent XSS and ensure it's a safe URL
      const url = config.button.onClick.url;
      
      const isAbsoluteHttp = /^https?:\/\//i.test(url);
      const isSafeRelative = /^\/(?!\/|(?:javascript:|data:|vbscript:))/i.test(url);
      const isValidUrl = isAbsoluteHttp || isSafeRelative;
      
      if (isValidUrl) {
        // Open with security measures to prevent reverse tabnabbing
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
        
        // Additional security: ensure the new window doesn't have access to this window
        if (newWindow) {
          newWindow.opener = null;
        }
      }
    }
  }

  let enabledIcon: IconConfig = {} as IconConfig;
  if (config?.icon && config?.icon?.length) {
    const [found] = config?.icon?.filter(icon => icon.enabled) || [];
    if (found) {
      enabledIcon = found;
    }
  }

  return (
    <StyledSaleBadge
      buttonConfig={config?.button}
      labelConfig={config?.label}
      onClick={config?.button?.onClick?.url ? handleClick : undefined}
    >
      <BadgeLabel labelConfig={config?.label}>
        {(enabledIcon?.content && enabledIcon?.content?.trim() !== '') && (
          <BadgeIcon iconConfig={enabledIcon} dangerouslySetInnerHTML={{ __html: enabledIcon?.content }} />
        )}
        <b>{config?.label?.text || 'On Sale'}</b>
      </BadgeLabel>
    </StyledSaleBadge>
  );
}

// Price type map
const priceTypeMap: Record<number, string> = {
	1: "Regular Price",
	2: "Price Testing",
	3: "Temporary Mark-Up",
	4: "Temporary Mark-Down",
	5: "Clearance",
	6: "Ad hoc Testing",
	7: "PLA Push",
	8: "Optimization",
	9: "Control",
	10: "Test Price Increase",
	11: "Test Price Decrease",
	12: "Overstock Discount",
	13: "Temp Reduce",
	14: "OOS Temp Increase",
	15: "Ecomm vs Marketplace",
	16: "High Performance",
	17: "Promotion",
	18: "CGM Ad-hoc",
};

export const isPromo = (pricingStatusId: number, badges: any) => {
  const { badgeName } = badges || {}

  const badgeMapping = badgeName?.split("|").map((name) => name.trim());

  const pricingStatusLabel =
		priceTypeMap[pricingStatusId ?? 0] || "";

	if (badgeMapping?.indexOf(pricingStatusLabel) === -1) {
		return false;
	}

  return true;
}


export const PromoBadge = ({ data, config, badgeType = 'list' }) => {
  const isLoadedRef = useRef(false);

  useEffect(() => {
      if (!data?.sku || !data?.pageType || isLoadedRef.current) {
        return;
      }

      trackPromoBadgeImpression({
        pageType: data?.pageType,
        sku: data?.sku,
      })
      isLoadedRef.current = true;
    }, 
    [data?.pageType, data?.sku],
  )

  return ( badgeType === "list"
    ? <StyledPromoBadge data-testid="promo-badge">
      <SaleBadge config={config} />
    </StyledPromoBadge>
    : <div data-testid="promo-badge">
      <SaleBadge config={config} />
    </div>
  );
}
